import React from 'react';

import { useParams } from 'react-router';

import { ArquivoFormComp, ArquivoListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function ArquivoForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('ARQUIVO', id)) return alertNotPermission();

    return (
        <FormProvider>
            <ArquivoFormComp />
        </FormProvider>
    );
}

export function ArquivoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['ARQUIVO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ArquivoListComp />
        </ListagemProvider>
    );
}
